<script>
	// @ts-nocheck
	import { onMount } from 'svelte';
	import Button from '../ui/button/button.svelte';
	import { openMobileNav } from '../nav/mobileNav.svelte';

	import heroImage from '/src/lib/assets/images/hero-carousel-1.jpg?enhanced';

	const videoUrl = 'https://ik.imagekit.io/codec/Tassie%20Tours/hero-video.mp4';
	const startTime = 2;
	const endTime = 27;

	let videoElement;

	onMount(() => {
		if (videoElement) {
			videoElement.currentTime = startTime;

			videoElement.addEventListener('timeupdate', () => {
				if (videoElement.currentTime >= endTime) {
					videoElement.currentTime = startTime;
				}
			});
		}
	});

	function handleViewAllTours(event) {
		if (window.matchMedia('(max-width: 1279px)').matches) {
			event.preventDefault();
			openMobileNav('tours');
		}
	}

	function handleAnchorClick(event) {
		event.preventDefault();
		const link = event.currentTarget;
		const anchorId = new URL(link.href).hash.replace('#', '');
		const anchor = document.getElementById(anchorId);
		window.scrollTo({
			top: anchor.offsetTop,
			behavior: 'smooth'
		});
	}
</script>

<section
	class="relative mx-auto flex h-[700px] flex-col items-center justify-center overflow-hidden"
>
	<div
		class="absolute bottom-0 left-0 z-10 h-48 w-full"
		style="clip-path: polygon(26% 96%,100% 73%,100% 100%,0 100%,0 88%);"
	>
		<div class="h-full bg-white"></div>
	</div>
	<div class="absolute inset-0 h-[700px] w-full">
		<video
			bind:this={videoElement}
			autoplay
			muted
			playsinline
			poster={heroImage}
			class="scaled-video h-full w-full object-cover"
		>
			<source src={videoUrl} type="video/mp4" />
		</video>
	</div>

	<div class="absolute inset-0 bg-foreground/40"></div>

	<div
		class="pointer-events-none absolute inset-0 mx-auto flex h-[700px] w-full max-w-7xl flex-col justify-center px-4"
	>
		<enhanced:img
			sizes="270px"
			src="/src/lib/assets/logo/logo-white.png"
			class="mx-auto h-24 w-auto lg:h-44"
			alt="Tassie Tours Logo"
		/>
		<h1
			class="mx-auto mt-6 max-w-2xl scroll-m-20 text-center text-xl font-bold leading-loose tracking-tight text-background lg:text-3xl"
		>
			Welcome to Tassie Tours, your gateway to unforgettable Tasmanian Adventures
		</h1>
		<div class="mx-auto flex items-center justify-center gap-4">
			<Button
				data-sveltekit-noscroll
				href="/tours#dayTours"
				onclick={handleViewAllTours}
				class="pointer-events-auto mx-auto mt-8 rounded-full bg-tt-red px-6 font-semibold hover:bg-tt-red/90 lg:text-lg"
				>View all tours</Button
			>
			<Button
				data-sveltekit-noscroll
				onclick={handleAnchorClick}
				variant="outline"
				href="#explore"
				class="pointer-events-auto mx-auto mt-8 rounded-full border-2 bg-transparent px-6 font-semibold text-background lg:text-lg"
				>Explore Tassie</Button
			>
		</div>
	</div>
</section>

<style>
	.scaled-video {
		height: 100%;
		width: 100%;
		object-fit: cover;
		animation: slow-scale 15s ease-in-out infinite alternate;
	}
</style>
